import React, { useState } from 'react';

const FloatingLabelInputAutocomplete = ({
  label,
  name,
  id,
  type = 'text',
  value,
  onChange,
  placeholder = '',
  required = false,
  autocomplete = 'off',
  className = '',
  suggestions = [], // Array of suggestions
  onSelectSuggestion, // Function to handle when a suggestion is selected
  loading, // Loading state
}) => {
  const [activeIndex, setActiveIndex] = useState(-1); // Track the active suggestion

  const handleKeyDown = (e) => {
    if (suggestions.length === 0) return;

    switch (e.key) {
      case 'ArrowDown':
        setActiveIndex((prev) => (prev + 1) % suggestions.length);
        break;
      case 'ArrowUp':
        setActiveIndex((prev) => (prev - 1 + suggestions.length) % suggestions.length);
        break;
      case 'Enter':
        if (activeIndex >= 0) {
          onSelectSuggestion(suggestions[activeIndex]);
          setActiveIndex(-1);
        }
        break;
      default:
        break;
    }
  };

  const handleSuggestionClick = (suggestion) => {
    onSelectSuggestion(suggestion);
    setActiveIndex(-1);
  };

  return (
    <div className={`relative w-full ${className}`}>
      <input
        type={type}
        name={name}
        id={id}
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        required={required}
        autoComplete={autocomplete}
        className={`peer h-9 w-full border border-gray-300 rounded-md px-3 placeholder-transparent focus:outline-none focus:ring-blue-500 focus:border-blue-500 ${className}`}
      />
      <label
        htmlFor={id}
        className="absolute left-3 -top-3.5 bg-white px-1 text-sm floating_textbox_label_lineheight text-gray-500 transition-all 
          peer-placeholder-shown:top-2.5 
          peer-focus:-top-3.5 peer-focus:text-sm peer-focus:text-blue-500"
      >
        {label}
      </label>

      {/* Suggestions dropdown */}
      {suggestions.length > 0 && (
        <ul className="absolute w-full bg-white border border-gray-300 rounded-md shadow-lg z-10">
          {suggestions.map((suggestion, index) => (
            <li
              key={index}
              onClick={() => handleSuggestionClick(suggestion)}
              className={`px-3 py-2 cursor-pointer ${
                index === activeIndex ? 'bg-blue-500 text-white' : 'hover:bg-gray-200'
              }`}
            >
              {suggestion.label}
            </li>
          ))}
        </ul>
      )}

      {/* Loading dots inside the input field (right side) */}
      {loading && (
        <div className="absolute right-3 top-2 transform -translate-y-2 text-gray-500">
          ...{/* Loading dots */}
        </div>
      )}
      {loading && suggestions.length === 0 && (
        <div className="absolute w-full bg-white border border-gray-300 mt-1 rounded-md shadow-lg py-2 text-center text-gray-500">
          ...Loading
        </div>
      )}
    </div>
  );
};

export default FloatingLabelInputAutocomplete;
